"use strict";

exports.__esModule = true;
exports.HeaderButtonSubContainer = exports.HeaderButtonItemRight = exports.HeaderButtonItemLeft = exports.HeaderButtonItemCenter = exports.HeaderButtonGroup = exports.HeaderButtonContainer = exports.DetailsWrapper = exports.DetailsSectionWrapper = exports.DetailsSectionWide = exports.DetailsSection = exports.DetailsHeader = exports.DetailsContainer = exports.DetailsCommentsSection = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DetailsWrapper = exports.DetailsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__DetailsWrapper",
  componentId: "sc-1w6soaj-0"
})(["width:", ";height:", ";max-height:", ";min-height:390px;"], function (props) {
  return props.width ? props.width - 20 + "px" : "100%";
}, function (props) {
  return props.height ? props.height + "px" : "100%";
}, function (props) {
  return props.isFullScreen ? "unset" : "390px";
});
var DetailsContainer = exports.DetailsContainer = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__DetailsContainer",
  componentId: "sc-1w6soaj-1"
})(["margin:", ";display:grid;width:", ";height:", ";max-height:", ";min-height:370px;overflow:auto;grid-template-rows:", " 1fr;"], function (props) {
  return props.isFullScreen ? "0 auto" : "5px auto";
}, function (props) {
  return props.isFullScreen || !props.width ? "100%" : props.width - 40 + "px";
}, function (props) {
  return props.isFullScreen || !props.height ? "100%" : props.height - 12 + "px";
}, function (props) {
  return props.isFullScreen ? "none" : "370px";
}, function (props) {
  return props.isFullScreen ? "48px" : "30px";
});
var DetailsSectionWrapper = exports.DetailsSectionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__DetailsSectionWrapper",
  componentId: "sc-1w6soaj-2"
})(["width:100%;display:grid;grid-template-columns:repeat(auto-fit,minmax(400px,1fr));grid-template-rows:", ";grid-gap:1rem;padding:", ";"], function (props) {
  return props.isFullScreen ? "repeat(auto-fit, 1fr)" : "repeat(auto-fit, 330px)";
}, function (props) {
  return props.isFullScreen ? "10px 20px" : "10px 0 0 0";
});
var DetailsHeader = exports.DetailsHeader = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__DetailsHeader",
  componentId: "sc-1w6soaj-3"
})(["width:100%;display:flex;height:", ";justify-content:", ";align-items:center;margin:0;padding:", ";border-top:1px solid ", ";border-bottom:1px solid ", ";"], function (props) {
  return props.isFullScreen ? "48px" : "40px";
}, function (props) {
  return props.showRightAligned ? "flex-end" : "space-between";
}, function (props) {
  return props.isFullScreen ? "5px 20px" : "unset";
}, function (props) {
  return props.isFullScreen ? (0, _Theme.val)("LogbookBorderColor") : "none";
}, function (props) {
  return props.isFullScreen ? (0, _Theme.val)("LogbookBorderColor") : "none";
});
var HeaderButtonGroup = exports.HeaderButtonGroup = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__HeaderButtonGroup",
  componentId: "sc-1w6soaj-4"
})(["display:flex;button{margin-right:5px;}"]);
var HeaderButtonContainer = exports.HeaderButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__HeaderButtonContainer",
  componentId: "sc-1w6soaj-5"
})(["display:grid;width:100%;grid-template-columns:1fr 1fr;"]);
var HeaderButtonSubContainer = exports.HeaderButtonSubContainer = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__HeaderButtonSubContainer",
  componentId: "sc-1w6soaj-6"
})(["display:flex;justify-content:space-between;width:100%;padding:22px;"]);
var HeaderButtonItemCenter = exports.HeaderButtonItemCenter = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__HeaderButtonItemCenter",
  componentId: "sc-1w6soaj-7"
})(["display:flex;text-align:center;"]);
var HeaderButtonItemLeft = exports.HeaderButtonItemLeft = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__HeaderButtonItemLeft",
  componentId: "sc-1w6soaj-8"
})(["display:flex;text-align:left;"]);
var HeaderButtonItemRight = exports.HeaderButtonItemRight = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__HeaderButtonItemRight",
  componentId: "sc-1w6soaj-9"
})(["display:flex;text-align:right;"]);
var DetailsSection = exports.DetailsSection = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__DetailsSection",
  componentId: "sc-1w6soaj-10"
})(["display:flex;flex-direction:column;background-color:", ";padding:5px 10px;overflow:auto;"], (0, _Theme.val)("TicketDetailsBackground"));
var DetailsSectionWide = exports.DetailsSectionWide = (0, _styledComponents["default"])(DetailsSection).withConfig({
  displayName: "DetailsComponents__DetailsSectionWide",
  componentId: "sc-1w6soaj-11"
})(["display:flex;flex-direction:column;background-color:", ";padding:5px 10px;overflow:auto;grid-column:span 2;"], (0, _Theme.val)("TicketDetailsBackground"));
var DetailsCommentsSection = exports.DetailsCommentsSection = _styledComponents["default"].div.withConfig({
  displayName: "DetailsComponents__DetailsCommentsSection",
  componentId: "sc-1w6soaj-12"
})(["display:flex;flex-direction:column;padding:5px 10px;"]);